import { useRef, useState } from "react";
import FormRow from "../../interface/FormRow";
import styled from "styled-components";
import ReactCrop, {
  centerCrop,
  convertToPixelCrop,
  makeAspectCrop,
} from "react-image-crop";
import toast from "react-hot-toast";
import ButtonRound from "../../interface/ButtonRound";
import { MdOutlineAddAPhoto } from "react-icons/md";
import setCanvasPreview from "./setCanvasPreview";

const ParentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center; // Horizontally center the children
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledImage = styled.img`
  max-height: 70vh;
`;

const CropButton = styled.div`
  display: flex;
  align-self: center;
  padding: 1.5rem;
`;

const ASPECT_RATIO = 1;
const MIN_DIMENSION = 200;

const ImageEdit = ({ onClose, onImageUpdate }) => {
  const ImgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [imgSrc, setImgSrc] = useState("");
  const [crop, setCrop] = useState();

  const onSelectFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.addEventListener("load", () => {
      const imageElement = new Image();
      const imageUrl = reader.result?.toString() || "";
      imageElement.src = imageUrl;

      imageElement.addEventListener("load", (e) => {
        const { naturalWidth, naturalHeight } = e.currentTarget;
        if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
          toast.error("Image must be at least 500 x 500 pixels.");
          return setImgSrc("");
        }
      });
      setImgSrc(imageUrl);
    });
    reader.readAsDataURL(file);
  };

  const onImageLoad = (e) => {
    const imageElement = e.currentTarget;
    if (imageElement.naturalHeight > 1000) {
      // Create an off-screen canvas
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Set the canvas size to maintain the aspect ratio but limit the height to 1000px
      const scale = 1000 / imageElement.naturalHeight;
      canvas.width = imageElement.naturalWidth * scale;
      canvas.height = 1000; // max height

      // Draw the image to the canvas at the new size
      ctx.drawImage(imageElement, 0, 0, canvas.width, canvas.height);

      // Replace the image src with the canvas data URL
      imageElement.src = canvas.toDataURL();
    }

    const { width, height, naturalHeight, naturalWidth } = e.currentTarget;
    const cropPercentage = {
      width: (MIN_DIMENSION / width) * 100,
      height: (MIN_DIMENSION / height) * 100,
    };
    console.log(height, width);
    const crop = makeAspectCrop(
      {
        unit: "%",
        ...cropPercentage,
      },
      ASPECT_RATIO,
      width,
      height
    );
    const centeredCrop = centerCrop(crop, width, height);
    setCrop(centeredCrop);
  };

  const onCropChange = (pixelCrop, percentCrop) => {
    setCrop(percentCrop);
  };

  return (
    <>
      <FormRow label="User Image">
        <input type="file" accept="image/*" onChange={onSelectFile} />
        {/* {userImage && <img src={URL.createObjectURL(userImage)} alt="User" />} */}
      </FormRow>
      {imgSrc && (
        <ParentContainer>
          <ImageContainer>
            <ReactCrop
              crop={crop}
              circularCrop
              onChange={onCropChange}
              keepSelection
              aspect={ASPECT_RATIO}
              minWidth={MIN_DIMENSION}
            >
              <StyledImage
                ref={ImgRef}
                src={imgSrc}
                alt="Upload"
                onLoad={onImageLoad}
              />
            </ReactCrop>
          </ImageContainer>
          <CropButton>
            <ButtonRound
              onClick={() => {
                console.log("clicky click");
                setCanvasPreview(
                  ImgRef.current,
                  previewCanvasRef.current,
                  convertToPixelCrop(
                    crop,
                    ImgRef.current.width,
                    ImgRef.current.height
                  )
                );
                const dataUrl = previewCanvasRef.current.toDataURL();
                onImageUpdate(dataUrl);
                onClose?.();
              }}
            >
              <MdOutlineAddAPhoto />
            </ButtonRound>
          </CropButton>
          {crop && (
            <canvas
              ref={previewCanvasRef}
              className="mt-4"
              style={{
                display: "none",
                border: "1px solid black",
                objectFit: "contain",
                width: 150,
                height: 150,
              }}
            />
          )}
        </ParentContainer>
      )}
    </>
  );
};

export default ImageEdit;
